<template>
    <div class="container">
        <div
            :id="list[1]"
            class="main-2">
            <img
                src="../../assets/images/main2-bg.png"
                alt=""
                class="main2-bg" />
            <div class="main2-content">
                <div class="main2-title">Sobre Nosotros</div>
                <div class="main-passage">
                    <span style="font-weight: 500">FuturePymes SA DE CV</span> nació en 2024, es una empresa legalmente constituida en México que ofrece a través de una app móvil créditos personales
                    100% en línea. Queremos contribuir de forma rápida, segura y responsable al desarrollo financiero de nuestros usuarios, brindándoles el apoyo económico que necesitan para alcanzar
                    sus metas financieras y mejorar su vida. Para FuturePymes SA DE CV, nuestros usuarios y sus familias son lo más importante y sabemos que en ocasiones hay emergencias que no pueden
                    esperar, es por eso que trabajamos cada vez con mayor rapidez y flexibilidad. Nosotros confiamos en nuestros usuarios por lo que nuestros créditos no requieren aval o garantía.
                </div>
            </div>
        </div>
        <div
            :id="list[2]"
            style="position: relative">
            <img
                src="../../assets/images/top-bg.png"
                alt=""
                class="header-banner" />
            <div class="header-adv">
                <div class="header-left">
                    <div class="header-info">Préstamo personal <br />confiable</div>
                    <div class="header-message">Obtén monto de hasta <span class="price">$20,000</span> de forma rápida <br />y segura. El depósito es en minutos.</div>
                    <div class="header-button">
                        <div
                            class="button-wrap"
                            @click="toGoogle">
                            <img
                                src="../../assets/images/btn-bg1.png"
                                alt=""
                                class="btn-bg1" />
                            <span class="btn-name name-color1">Descarga y pide tu préstamo hoy</span>
                        </div>
                    </div>
                    <div
                        class="wrap-app-store"
                        @click="goAppstore">
                        <img
                            src="../../assets/images/apple.svg"
                            alt="" />
                        <span>App Store</span>
                    </div>
                </div>
                <div class="header-right">
                    <img
                        src="../../assets/images/Samsung.png"
                        alt=""
                        class="Samsung" />
                </div>
            </div>
        </div>
        <div
            :id="list[3]"
            class="main-3">
            <div class="main3-content">
                <div class="main3-title">¿Por qué elegirnos?</div>
                <img
                    src="../../assets/images/main3-line.png"
                    alt=""
                    class="main3-line" />
                <ul class="main3-ul">
                    <li class="main3-item item-color-1">
                        <img
                            src="../../assets/images/icon-1.png"
                            alt=""
                            class="main3-icon" />
                        <p class="main3-item-title">Servicio 24 hrs</p>
                        <p class="main3-item-des">Atención las 24 horas los<br />365 días del año.</p>
                    </li>
                    <li class="main3-item item-color-2">
                        <img
                            src="../../assets/images/icon-2.png"
                            alt=""
                            class="main3-icon" />
                        <p class="main3-item-title">Respuesta Inmediata</p>
                        <p class="main3-item-des">Resolucion de imediato y <br />deposito en 5 minutos</p>
                    </li>
                    <li class="main3-item item-color-3">
                        <img
                            src="../../assets/images/icon-3.png"
                            alt=""
                            class="main3-icon" />
                        <p class="main3-item-title">Sin 'Letras pequeñas'</p>
                        <p class="main3-item-des">Transparencia durante el proceso.</p>
                    </li>
                    <li class="main3-item item-color-4">
                        <img
                            src="../../assets/images/icon-4.png"
                            alt=""
                            class="main3-icon" />
                        <p class="main3-item-title">Seguridad</p>
                        <p class="main3-item-des">Tus datos personales están <br />encriptados y protegidos.</p>
                    </li>
                </ul>
                <div class="main3-quote">
                    <img
                        src="../../assets/images/main3-bg.png"
                        alt=""
                        class="main3-bg" />
                    <div class="main3-quote-title">Lo que las personas opinan de Futuro</div>
                    <div class="main3-quote-voice">
                        <ul>
                            <li>
                                <img
                                    src="../../assets/images/main3-bg-1.png"
                                    alt=""
                                    class="main3-bg-quote" />
                                <img
                                    src="../../assets/images/mark1.png"
                                    alt=""
                                    class="mark" />
                                <img
                                    src="../../assets/images/avatar1.png"
                                    alt=""
                                    class="avatar" />
                                <p class="main3-quote-message">
                                    Excelente opción para necesidades económicas urgentes, cobran poco interés y te dan más tiempo para pagar que otras apps, la recomiendo
                                </p>
                            </li>
                            <li class="main3-quote-item">
                                <img
                                    src="../../assets/images/main3-bg-2.png"
                                    alt=""
                                    class="main3-bg-quote" />
                                <img
                                    src="../../assets/images/mark2.png"
                                    alt=""
                                    class="mark" />
                                <img
                                    src="../../assets/images/avatar2.png"
                                    alt=""
                                    class="avatar" />
                                <p class="main3-quote-message">Esta aplicación me ha brindado créditos más favorables que otras financieras. Muy buena experiencia.</p>
                            </li>
                            <li>
                                <img
                                    src="../../assets/images/main3-bg-3.png"
                                    alt=""
                                    class="main3-bg-quote" />
                                <img
                                    src="../../assets/images/mark2.png"
                                    alt=""
                                    class="mark" />
                                <img
                                    src="../../assets/images/avatar3.png"
                                    alt=""
                                    class="avatar" />
                                <p class="main3-quote-message">Se ha convertido en una aliada, ya que he podido resolver de forma rápida mis problemas económicos.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div
            :id="list[4]"
            class="main-4">
            <div class="main4-content">
                <div class="main4-title">Solicita en <span class="color-yellow">3</span> sencillos pasos</div>
                <div class="main4-content-right">
                    <div class="content-step">
                        <div class="main4-content-step">
                            <img
                                src="../../assets/images/icon-download.png"
                                alt=""
                                class="icon-step" />
                            <p class="step1-text">Descarga la app</p>
                        </div>
                        <div class="main4-content-step">
                            <img
                                src="../../assets/images/message.png"
                                alt=""
                                class="icon-step" />
                            <p class="step1-text">Llena la solicitud</p>
                        </div>
                        <div class="main4-content-step">
                            <img
                                src="../../assets/images/dollar.png"
                                alt=""
                                class="icon-step" />
                            <p class="step1-text">Recibe dinero</p>
                        </div>
                    </div>
                    <img
                        src="../../assets/images/step-line.png"
                        alt=""
                        class="step-line" />
                    <div class="main4-content-two">
                        <a
                            href="https://play.google.com/store/apps/details?id=com.futuro.mx"
                            target="_black"
                            class="main4-content-des"
                            >Busca Futuro en Play Store o da clic aquí para descargarla</a
                        >
                        <div class="main4-content-des mg-lr-20">Revisa que tu información sea correcta, esto ayuda a obtener un crédito</div>
                        <div class="main4-content-des">Una vez aprobada tu solicitud, depositaremos a tu cuenta el crédito</div>
                    </div>
                </div>
            </div>
        </div>
        <div
            :id="list[5]"
            class="main-5">
            <div class="main5-content">
                <img
                    src="../../assets/images/question.png"
                    alt=""
                    class="img-question" />
                <div class="flex-wrap">
                    <span class="main5-title"> Preguntas frecuentes</span>
                    <img
                        src="../../assets/images/main3-line.png"
                        alt=""
                        class="main3-line" />
                </div>
                <div class="main5-question">
                    <div class="question-item mg-r-20">
                        <p class="ques-mg">1.¿Cuáles son los requisitos?</p>
                        <p class="ques-mg-l">Tener celular, INE y cuenta bancaria</p>
                    </div>
                    <div class="question-item">
                        <p class="ques-mg">2. ¿Cuánto tiempo tarda?</p>
                        <p class="ques-mg-l">El proceso de solicitud toma menos de 10 minutos. Una vez aprobado el crédito y que hayas aceptado el contrato, el depósito se realizará de inmediato.</p>
                    </div>
                    <div class="question-item mg-r-20">
                        <p class="ques-mg">3. ¿Plazo para pagar?</p>
                        <p class="ques-mg-l">Periodo mínimo de 90 días y máximo de hasta 12 meses, de acuerdo con lo aprobado al cliente.</p>
                    </div>
                    <div class="question-item">
                        <p class="ques-mg">4. ¿Qué cantidad otorgan?</p>
                        <p class="ques-mg-l">Ofrecemos créditos desde $1.500 hasta $20.000 las 24 horas del día, todo el año.</p>
                    </div>
                </div>
            </div>
        </div>
        <div
            :id="list[6]"
            class="main-6">
            <img
                src="../../assets/images/qualifications.jpeg"
                alt="" />
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            active: 0,
            list: ['md00', 'md01', 'md02', 'md03', 'md04', 'md05', 'md06']
        }
    },
    created () {

    },
    mounted () {

    },
    methods: {
        toGoogle () {
            window.open('https://play.google.com/store/apps/details?id=com.futuro.mx', '_blank')
        },
        goAppstore () {
            window.open('https://tuku.onelink.me/oiHV/g33wyyn4', '_blank')
        }
    }
}
</script>
<style  scoped>
/* @import '@/assets/css/style.css'; */
</style>


// WEBPACK FOOTER //
// src/views/home/home.vue